import React from "react"

function TimelineWrapper(props) {
  return <div className="timeline">{props.children}</div>
}

export default TimelineWrapper
